import * as React from 'react';
import { Button, ButtonProps } from 'reactstrap';

interface IconButtonProps extends ButtonProps {
  icon?: any;
  label: string;
  isLoading?: boolean;
  htmlFor?: string;
  className?: string;
}

export const IconButton: React.FC<IconButtonProps> = (props) => {
  const { icon, isLoading, htmlFor, label, className, ...rest } = props;
  return (
    <Button disabled={isLoading} className={className} {...rest}>
      {icon && !isLoading && (
        <span className="me-2" style={{ position: 'relative', top: '-2px' }}>
          {icon}
        </span>
      )}
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
          style={{ position: 'relative', top: '-2px' }}
        />
      )}
      <label
        className="m-0"
        htmlFor={htmlFor}
        style={{ cursor: 'pointer', wordBreak: 'break-word' }}
      >
        {label}
      </label>
    </Button>
  );
};

export const IconButtonDisplayLabelBelow: React.FC<IconButtonProps> = (
  props,
) => {
  const { icon, isLoading, htmlFor, label, ...rest } = props;
  return (
    <Button disabled={isLoading} {...rest}>
      {icon && !isLoading && (
        <span className="me-2" style={{ position: 'relative', top: '-2px' }}>
          {icon}
        </span>
      )}
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
          style={{ position: 'relative', top: '-2px' }}
        />
      )}
      <label
        className="m-0"
        htmlFor={htmlFor}
        style={{ cursor: 'pointer', wordBreak: 'break-word', display: 'block' }}
      >
        {label}
      </label>
    </Button>
  );
};
